import { defineStore, getActivePinia } from 'pinia'

import state from './state'

export const windowStore = (gaApp) => {
  const init = defineStore('appWindow', {
    state,
  })

  return init(getActivePinia())
}
